import React, { Component } from 'react';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import TextBlink from '../../../common/table/TextBlink';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { REDUCER_NAME, updateBidAsk, updateListDerivative } from '../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { connect } from 'react-redux';
import Table from '../../../common/table/Table';
import ConstSummary from '../summary/Const';
import Const from './Const';
import { omit, includes } from 'lodash';
import {
  getColorPrice,
  getColorRedGreen,
  getColorRefPrice,
} from '../../../helpers/Color';
import {
  formatPercent,
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../helpers/Text';
import {
  getDataFollowKeyByDot,
  syncComponentSelector,
} from './../../../helpers/Common';
import DayRange from './DayRange';
import { compose } from 'redux';
import TradingViewUrl from '../../../common/TradingViewUrl';
import { formatDataBidAsk } from './../../../helpers/Common';
import TimeZoneHandle from '../../../common/timezone-handle';

const indexHideColumns = [];
const bondHideColumns = [Const.derivative.BASIS];

const getDataFromRedux = state =>
  state[REDUCER_NAME].listDerivativeTableByTicker;

const getMatchPrice = item => {
  const matchPrice = getDataFollowKeyByDot(item, Const.derivative.MATCH_PRICE);
  const currentPrice = getDataFollowKeyByDot(
    item,
    Const.derivative.CURRENT_PRICE,
  );

  return matchPrice || currentPrice;
};

class TableDerivative extends Component {
  componentDidMount() {
    MessageHub.subscribe(
      ChanelConfig.DerivativeChannel,
      this.onReceiveDerivatives,
    );
    MessageHub.subscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(
      ChanelConfig.DerivativeChannel,
      this.onReceiveDerivatives,
    );
    MessageHub.unsubscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  }

  onReceiveBidAsk = data => {
    const { ids, updateBidAsk } = this.props;
    const bidAskData = data.filter(item => ids.includes(item.organCode));
    if (bidAskData.length) {
      const updateData = {};
      bidAskData.forEach(item => {
        updateData[item.organCode] = item;
      });
      updateBidAsk(updateData);
    }
  };

  onReceiveDerivatives = derivatives => {
    const { ids, updateListDerivative, derivativeData } = this.props;

    const data = derivatives.reduce((result, derivative) => {
      const id = getDataFollowKeyByDot(derivative, 'derivativeCode');
      if (ids.includes(id)) {
        return {
          ...result,
          [id]: {
            ...derivativeData[id],
            ...derivative,
            lastTradingDate: derivativeData[id].lastTradingDate,
          },
        };
      }

      return result;
    }, {});
    updateListDerivative(data);
  };

  getHideColumns = () => {
    const { watchListId } = this.props;
    const isBond = watchListId === ConstSummary.derivativeTypes.BONDS;

    return isBond ? bondHideColumns : indexHideColumns;
  };

  getTradingViewCode = derivativeCode => {
    const { listDerivativeByDerivativeCode } = this.props;
    if (!listDerivativeByDerivativeCode[derivativeCode]) {
      return '';
    }

    return listDerivativeByDerivativeCode[derivativeCode].organCode;
  };

  getLastTradingDate = derivativeCode => {
    const { listDerivativeByDerivativeCode } = this.props;
    if (!listDerivativeByDerivativeCode[derivativeCode]) {
      return '';
    }

    return listDerivativeByDerivativeCode[derivativeCode].lastTradingDate;
  };

  getSchema = () => {
    const { summaryBidAskRealtimeData } = this.props;
    return Object.keys(
      omit(Const.derivative, Const.listIgnoreColumnDerivative),
    ).map((item, index) => {
      const key = Const.derivative[item];
      const title = `watchListSummary.listTitleDerivativeTable.${item}`;
      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => (
            <div className="px-10">
              <span>
                <TradingViewUrl
                  code={this.getTradingViewCode(
                    getDataFollowKeyByDot(
                      item,
                      Const.derivative.DERIVATIVE_CODE,
                    ),
                  )}
                />
                &nbsp;{text}
              </span>
            </div>
          ),
        };
      }

      if (key === Const.derivative.REFERENCE_PRICE) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => (
            <span
              className={getColorRefPrice(
                formatTextFloat(formatPrice(text)),
                'text',
              )}
            >
              <span>
                <TextBlink
                  item={item}
                  tradingDate={Const.derivative.TRADING_DATE}
                >
                  {formatTextFloat(text)}
                </TextBlink>
              </span>
            </span>
          ),
        };
      }

      if (key === Const.derivative.MATCHED) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => {
            const matchPrice = getMatchPrice(item);
            const className = getColorPrice(
              matchPrice,
              getDataFollowKeyByDot(item, Const.derivative.REFERENCE_PRICE),
              getDataFollowKeyByDot(item, Const.derivative.CEILING_PRICE),
              getDataFollowKeyByDot(item, Const.derivative.FLOOR_PRICE),
              'text',
            );
            return (
              <span className={className}>
                <TextBlink
                  item={item}
                  tradingDate={Const.derivative.TRADING_DATE}
                >
                  {formatTextFloat(matchPrice, 2, true)}
                </TextBlink>
              </span>
            );
          },
        };
      }

      if (
        includes(
          [
            Const.derivative.CEILING_PRICE,
            Const.derivative.HIGHEST_PRICE,
            Const.derivative.FLOOR_PRICE,
            Const.derivative.OPEN_PRICE,
            Const.derivative.LOWEST_PRICE,
          ],
          key,
        )
      ) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => {
            const className = getColorPrice(
              getDataFollowKeyByDot(item, key),
              getDataFollowKeyByDot(item, Const.derivative.REFERENCE_PRICE),
              getDataFollowKeyByDot(item, Const.derivative.CEILING_PRICE),
              getDataFollowKeyByDot(item, Const.derivative.FLOOR_PRICE),
              'text',
            );
            return (
              <span className={className}>
                <TextBlink
                  item={item}
                  tradingDate={Const.derivative.TRADING_DATE}
                >
                  {formatTextFloat(formatPrice(text))}
                </TextBlink>
              </span>
            );
          },
        };
      }

      if (
        includes(
          [
            Const.derivative.FOREIGN_BUY_VOLUME_MATCHED,
            Const.derivative.TOTAL_SELL_TRADE_VOLUME,
            Const.derivative.TOTAL_BUY_TRADE_VOLUME,
            Const.derivative.FOREIGN_SELL_VOLUME_MATCHED,
          ],
          key,
        )
      ) {
        return {
          disableSort: true,
          ...result,
          render: text => <span>{formatTextFloat(formatVolume(text))}</span>,
        };
      }

      if (includes([Const.derivative.MATCH_VOLUME], key)) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => {
            const matchPrice = getMatchPrice(item);
            return (
              <span>
                <TextBlink
                  item={item}
                  tradingDate={Const.derivative.TRADING_DATE}
                >
                  {matchPrice === 0 ? '--' : formatTextFloat(text, 0)}
                </TextBlink>
              </span>
            );
          },
        }; //NOTE: match volume in derivative does not device 1000
      }

      if (key === Const.derivative.LAST_TRADING_DATE) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => (
            <div className="px-10 font-weight-light">
              <TimeZoneHandle
                time={this.getLastTradingDate(item.derivativeCode)}
                format={'MM/DD/YYYY'}
              />
            </div>
          ),
        };
      }

      if (key === Const.derivative.BASIS) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => {
            const matchPrice = getDataFollowKeyByDot(
              item,
              Const.derivative.MATCH_PRICE,
            );
            const currentPrice = getDataFollowKeyByDot(
              item,
              Const.derivative.CURRENT_PRICE,
            );
            const matched = currentPrice || matchPrice;

            return (
              <span>
                <TextBlink
                  item={item}
                  tradingDate={Const.derivative.TRADING_DATE}
                >
                  {formatTextFloat(
                    matched -
                      getDataFollowKeyByDot(item, Const.derivative.INDEX_VALUE),
                  )}
                </TextBlink>
              </span>
            );
          },
        };
      }

      if (key === Const.derivative.PRICE_CHANGE) {
        return {
          ...result,
          render: (text, item) => {
            if (text === -1) {
              return <div className="pl-8 pr-8">--</div>;
            }

            const colorClass = getColorRedGreen(text);
            return (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                <div className={colorClass}>{text}</div>
              </TextBlink>
            );
          },
        };
      }

      if (key === Const.derivative.DAY_RANGE) {
        return {
          disableSort: true,
          disableResize: true,
          thStyle: { width: '150px', textAlign: 'center' },
          ...result,
          render: (text, item) => {
            const matchPrice = getDataFollowKeyByDot(
              item,
              Const.derivative.MATCH_PRICE,
            );
            const currentPrice = getDataFollowKeyByDot(
              item,
              Const.derivative.CURRENT_PRICE,
            );
            const matched = currentPrice || matchPrice;
            const lowestPrice = getDataFollowKeyByDot(
              item,
              Const.derivative.LOWEST_PRICE,
            );
            const highestPrice = getDataFollowKeyByDot(
              item,
              Const.derivative.HIGHEST_PRICE,
            );
            const referencePrice = getDataFollowKeyByDot(
              item,
              Const.derivative.REFERENCE_PRICE,
            );
            return (
              <div className="px-10">
                {getMatchPrice(item) !== 0 && (
                  <DayRange
                    lowestPrice={lowestPrice}
                    highestPrice={highestPrice}
                    matchPrice={matched}
                    referencePrice={referencePrice}
                  />
                )}
              </div>
            );
          },
        };
      }

      if (key === Const.derivative.OPEN_INTEREST) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => (
            <span>
              <TextBlink
                item={item}
                tradingDate={Const.derivative.TRADING_DATE}
              >
                {formatTextFloat(text, 0)}
              </TextBlink>
            </span>
          ),
        };
      }

      if (
        includes(
          [Const.derivative.BEST_1_BID, Const.derivative.BEST_1_OFFER],
          key,
        )
      ) {
        return {
          disableSort: true,
          ...result,
          render: (text, item) => {
            const realtimeData =
              summaryBidAskRealtimeData[item.derivativeCode] || {};
            const data = {
              ...item,
              ...realtimeData,
            };
            const bidAsk = getDataFollowKeyByDot(data, key);
            const bidAskVolume =
              Const.derivative.BEST_1_BID === key
                ? getDataFollowKeyByDot(
                    data,
                    Const.derivative.BEST_1_BID_VOLUME,
                  )
                : getDataFollowKeyByDot(
                    data,
                    Const.derivative.BEST_1_OFFER_VOLUME,
                  );

            return (
              <span>
                <TextBlink
                  item={item}
                  tradingDate={Const.derivative.TRADING_DATE}
                >
                  {formatDataBidAsk(
                    bidAsk,
                    bidAskVolume,
                    getDataFollowKeyByDot(item, Const.derivative.TRADING_DATE),
                    true,
                    data.marketStatus,
                  ) || formatTextFloat(bidAsk)}
                </TextBlink>
              </span>
            );
          },
        };
      }

      return {
        disableSort: true,
        ...result,
        render: (text, item) => (
          <span>
            <TextBlink item={item} tradingDate={Const.derivative.TRADING_DATE}>
              {formatTextFloat(text)}
            </TextBlink>
          </span>
        ),
      };
    });
  };

  onRowClick = code => {
    const { listDerivativeByDerivativeCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listDerivativeByDerivativeCode[code],
      isDerivatives: true,
    });
  };

  render() {
    const { ids } = this.props;

    return (
      <div className="watchlist-summary-wrap d-flex flex-fill mt-10 pl-20 pr-20">
        <Table
          clickRow={this.onRowClick}
          ids={ids}
          resizable={true}
          columnDraggable={true}
          hideColumns={this.getHideColumns()}
          rowDraggable={false}
          getDataFromRedux={getDataFromRedux}
          schema={this.getSchema()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  ids: state[REDUCER_NAME].listTickerDerivativeTable,
  derivativeData: state[REDUCER_NAME].listDerivativeTableByTicker,
  watchListId: state[REDUCER_NAME].watchListId,
  summaryBidAskRealtimeData: state[REDUCER_NAME].summaryBidAskRealtimeData,
  listDerivativeByDerivativeCode:
    state[COMMON_REDUCER_NAME].listDerivativeByDerivativeCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});

const mapDispatchToProps = {
  updateListDerivative,
  updateBidAsk,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TableDerivative);
